module.exports = __webpack_public_path__ + "43d115cc8f149fd4a0b9928a3314da23.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/eyes/lazy-22.png
// module id = 1603
// module chunks = 0